import * as React from "react";
import {Col, Row} from "react-bootstrap";
import {Link, Route} from "react-router-dom";
import MediaQuery from "react-responsive";
import {MobileMedia, PCMedia} from "./Media";

const Header : React.FC = () => {
    const path = location.pathname;
    const menuLink = (paths: string[], url: string, linkName: string) => {
        if(paths.includes(path)) {
            return (
                <Col className={"menu active"}>
                    <div>
                        {linkName}
                    </div>
                </Col>
            );
        }
        return (
            <Col className={"menu"}>
                <a href={url}>{linkName}</a>
            </Col>
        );
    }

    return (
        <header>
            <Row className="header header-row">
                <Col className={"header-logo"} xs={6} md={4}>
                    <a href={"/"}>
                        <div className="clinic-name">医療法人ゆうあい会</div>
                        <img src="/images/miyaokaclinic.png" alt={"医療法人ゆうあい会 宮岡クリニック　大阪市　港区"}/>
                    </a>
                </Col>
                {/* @ts-expect-error Async Server Component */}
                <MediaQuery query={"(min-width: 768px)"}>
                    <Col className={"navi"} md={4}>
                        <Row>
                            <Col className={"icon-link"}>
                                <a href={"/access.html"}>
                                    <img src="/images/access.svg" width={50} height={50}/>
                                    <div>アクセス</div>
                                </a>
                            </Col>
                            <Col className={"icon-link"}>
                                <a href={"#clinic-hours"}>
                                    <img src="/images/consultation_hours.svg" width={50} height={50}/>
                                    <div>診療時間</div>
                                </a>
                            </Col>
                            <Col className={"icon-link"}>
                                <a href={"mailto:info@miyaoka-cl.com"}>
                                    <img src="/images/mail.svg" width={50} height={50}/>
                                    <div>お問い合わせ</div>
                                </a>
                            </Col>
                        </Row>
                    </Col>
                </MediaQuery>
                <Col className={"address"} xs={6} md={4}>
                    <PCMedia>
                        <div>〒 552-0012 大阪市港区市岡1-14-16</div>
                    </PCMedia>
                    <MobileMedia>
                        <div>大阪市港区市岡1-14-16</div>
                    </MobileMedia>
                    <div className={"tel"}>TEL:&nbsp;<span>06-6571-3506</span></div>
                </Col>
            </Row>
            <Row className={"header menu-bar"}>
                {menuLink(["/", "/index.html"], "/", "HOME")}
                {menuLink(["/intyou.html"], "/intyou.html", "医師紹介")}
                {menuLink(["/lifestyle.html"], "/lifestyle.html", "生活習慣病")}
                {menuLink(["/gan.html"], "/gan.html", "癌の早期発見")}
                {menuLink(["/zion.html"], "/zion.html", "ジオン注(痔核治療)")}
                {menuLink(["/setubi.html"], "/setubi.html", "設備案内")}
            </Row>
        </header>
    );
}

export default Header;
